import React from "react";

interface TabNavigationProps {
  activeTab: "general" | "medical" | "examination" | "diagnose" | "invoices";
  onTabChange: (tab: "general" | "medical" | "examination" | "diagnose" | "invoices") => void;
  theme?: "light" | "dark";
}

const TabNavigation: React.FC<TabNavigationProps> = ({ activeTab, onTabChange, theme = "light" }) => {
  const tabs: Array<{ id: "general" | "medical" | "examination" | "diagnose" | "invoices"; label: string }> = [
    { id: "general", label: "General" },
    { id: "medical", label: "Medical" },
    { id: "examination", label: "Examination" },
    { id: "diagnose", label: "Diagnose" },
    { id: "invoices", label: "Invoices" },
  ];

  return (
    <div className={`flex gap-1 sm:gap-2 mb-4 sm:mb-6 p-1 rounded-lg overflow-x-auto ${
      theme === "dark" ? "bg-slate-700" : "bg-slate-100"
    }`}>
      {tabs.map((tab) => (
        <button
          key={tab.id}
          onClick={() => onTabChange(tab.id)}
          className={`flex-shrink-0 py-1.5 sm:py-2 px-2 sm:px-3 rounded-md text-[10px] sm:text-xs font-medium transition-all whitespace-nowrap ${
            activeTab === tab.id
              ? theme === "dark"
                ? "bg-indigo-600 text-white shadow-sm"
                : "bg-white text-indigo-600 shadow-sm"
              : theme === "dark"
              ? "text-slate-300 hover:text-slate-100"
              : "text-slate-600 hover:text-slate-800"
          }`}
        >
          {tab.label}
        </button>
      ))}
    </div>
  );
};

export default TabNavigation;

